import axios from 'axios';
import { message } from 'antd';
import { axiosApiInstance } from '../../services/axiosApiInstance';

const api = `${process.env.REACT_APP_API_URL}/api/v1/sites/listAllSites`;

export interface DataType {
    name: string;
    id: string;
}

export const getAllSites = async () => {
    try {
        const res = await axiosApiInstance.get(api);
        return res.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response && error.response.data.detail) {
                if (error.response.status !== 401) {
                    const msg = error.response.data.detail
                    message.error(msg, 5);
                }
            }
        } else {
            message.error("Some error occurred", 5);
        }
    }
}